module.exports = __webpack_public_path__ + "img/bgr-catalog-theme-birthday.28a1d478.svg";